import {ToolName} from '../tools/tool-name';
import type {NavItem} from './default-config';
import type {Pixpen} from '../pixpen';
import {HISTORY_DISPLAY_NAMES} from '../tools/history/history-display-names';
import {MessageDescriptor} from '@common/i18n/message-descriptor';
import {message} from '@common/i18n/message';
import {CloseIcon} from '@common/icons/material/Close';
import {FileDownloadIcon} from '@common/icons/material/FileDownload';

export const DEFAULT_NAV_ITEMS: NavItem[] = [
  ...Object.values(ToolName).map(
    toolName => {
      return {
        name: toolName,
        icon: HISTORY_DISPLAY_NAMES[toolName].icon,
        action: toolName,
      };
    }
  ),
  {
    name: 'cancel',
    icon: CloseIcon,
    action: (editor: Pixpen) => {
      editor.close();
    }
  },
  {
    name: 'save',
    icon: FileDownloadIcon,
    action: async (editor: Pixpen) => {
      // Eğer custom callback varsa onu kullan
      if (editor.state.config.onSaveClick) {
        const format = editor.state.config.tools?.export?.defaultFormat || 'png';
        const quality = editor.state.config.tools?.export?.defaultQuality || 0.8;
        const filename = editor.state.config.tools?.export?.defaultName || 'image';

        const blob = await editor.tools.export.getBlob(format, quality);
        if (blob) {
          await editor.state.config.onSaveClick(blob, filename, format);
        }
      }
      // Export panel varsa göster
      else if (editor.state.config.ui?.showExportPanel) {
        editor.state.togglePanel('export', true);
      }
      // Varsayılan: direkt indir
      else {
        editor.tools.export.save();
      }
    }
  }
];

export const navItemMessages: Record<string, MessageDescriptor> = {
  filter: message('filter'),
  resize: message('resize'),
  crop: message('crop'),
  transform: message('transform'),
  draw: message('draw'),
  text: message('text'),
  shapes: message('shapes'),
  stickers: message('stickers'),
  corners: message('corners'),
  cancel: message('Cancel'),
  save: message('Save'),
};
